module.exports = __webpack_public_path__ + "img/parter-avatar7.31092c1d.png";